module.exports = __webpack_public_path__ + "img/Handy_Screen-Final_App.4d7d7efb.jpg";